import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import buildGTMCode from 'apps/gtm/utils/buildGTMCode';

const GoogleTagManager = (props) => {
  const { gtmId, dataLayerName } = props;
  return (
    <Fragment>
      <Helmet>
        <script>
          {buildGTMCode({ gtmId, dataLayerName })}
        </script>
      </Helmet>
      <noscript>
        <iframe
          src={`//www.googletagmanager.com/ns.html?id=${gtmId}`}
          height="0"
          width="0"
          title="GTM"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </Fragment>
  );
};

GoogleTagManager.defaultProps = {
  dataLayerName: 'dataLayer',
};

GoogleTagManager.propTypes = {
  gtmId: PropTypes.string.isRequired,
  dataLayerName: PropTypes.string,
};

export default GoogleTagManager;
